import { X } from "lucide-react";
import type { Toast } from "../hooks/useToast";

const borderColorMap: Record<Toast["type"], string> = {
  success: "border-l-green-500",
  error: "border-l-red-500",
  info: "border-l-blue-500",
};

const iconColorMap: Record<Toast["type"], string> = {
  success: "text-green-600",
  error: "text-red-600",
  info: "text-blue-600",
};

export default function ToastContainer({
  toasts,
  removeToast,
}: {
  toasts: Toast[];
  removeToast: (id: string) => void;
}) {
  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 max-w-sm">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`bg-white rounded-lg shadow-lg border border-grove-200 border-l-4 ${borderColorMap[toast.type]} px-4 py-3 flex items-start gap-3 animate-fade-in`}
        >
          <p className={`text-sm flex-1 ${iconColorMap[toast.type]}`}>
            {toast.message}
          </p>
          <button
            onClick={() => removeToast(toast.id)}
            className="text-bark-300 hover:text-bark-500 transition-colors flex-shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
